/* eslint-disable no-unneeded-ternary */
import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import Text from "@mobi/ds/components/Text"

import FormGroupReferral from "./components/FormGroupReferral"

import useFinancingConditions from "./hooks"

import "./style.scss"

const FinancingConditions = () => {
  const {
    handlePrevStep,
    onSubmitCallback,
    fields,
    form,
    handleRadioRequest,
    errorMessage,
    setErrorMessage,
    handleReferralClick,
    isLoading
  } = useFinancingConditions()

  const { isValid } = form
  const { financeIof } = fields

  return (
    <div className="proposalFinancingConditions">
      <div className="proposalFinancingConditions__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="proposalFinancingConditions__title">facilidades</h1>
        <Text p className="proposalFinancingConditions__text">
          Você pode escolher opções que facilitam o seu empréstimo:
        </Text>
        <Form onSubmit={onSubmitCallback} form={form}>
          <Text p className="proposalFinancingConditions__section space">
            IOF
          </Text>
          <div className="proposalFinancingConditions__box no-border">
            <Field
              field={financeIof}
              form={form}
              data-testid={financeIof.name}
              onClick={(e) => {
                handleRadioRequest(
                  "finance_iof",
                  !e.target.value === "true" ? true : false
                )
              }}
              isDisabled={isLoading}
            />
          </div>
          <div className="proposalFinancingConditions__box space">
            <Text p className="proposalFinancingConditions__label">
              Para a sua facilidade, podemos incluir o valor do IOF - Imposto
              sobre Operações Financeiras no valor total do seu empréstimo.
            </Text>
          </div>
          <FormGroupReferral
            form={form}
            track={handleReferralClick}
            isLoading={isLoading}
          />
          <Sender
            onPrev={handlePrevStep}
            isNextDisabled={!isValid}
            data_testid="submit"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default FinancingConditions
